import Modal from 'react-overlays/Modal'

export default function APNSuggestionModal({
  showAPNSuggestionModal,
  setShowAPNSuggestionModal,
}) {
  const handleClose = () => {
    setShowAPNSuggestionModal(false)
  }

  const renderBackdrop = (props) => <div className="backdrop" {...props} />

  return (
    <>
      <div className="bg-black bg-opacity-50 flex items-center justify-center fixed left-0 right-0 bottom-0 top-0 z-[200]"></div>
      <div>
        <Modal
          className="modal"
          show={showAPNSuggestionModal}
          onHide={handleClose}
          renderBackdrop={renderBackdrop}
          style={{
            // display: 'flex',
            position: 'absolute',
            top: '30%',
            left: '50%',
            marginTop: '-170px',
            marginLeft: '-250px',
            width: '500px',
            height: '70%',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1050,
          }}
        >
          <div>
            <div className="modal-header">
              <div className="modal-title">APN Suggestions</div>
              <div>
                <span className="close-button" onClick={handleClose}>
                  x
                </span>
              </div>
            </div>
            <div className="modal-desc flex items-center justify-center">
              <table border="1" className="dataframe">
                <thead>
                  <tr style={{ textAlign: 'center' }}>
                    <th>county_name</th>
                    <th>parcel_id</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Alameda</td>
                    <td>74-1265-45</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Alpine</td>
                    <td>006121019</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Amador</td>
                    <td>004154001000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Butte</td>
                    <td>025-090-009</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Calaveras</td>
                    <td>066015014000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Colusa</td>
                    <td>016-270-008-000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Contra Costa</td>
                    <td>098560028</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Del Norte</td>
                    <td>105300035000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>El Dorado</td>
                    <td>088400037</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Fresno</td>
                    <td>33816123S</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Humboldt</td>
                    <td>020027004</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Imperial</td>
                    <td>046-212-003</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Inyo</td>
                    <td>013-090-12</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Kern</td>
                    <td>18808208</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Kings</td>
                    <td>007410035000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Lake</td>
                    <td>01206918</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Lassen</td>
                    <td>001-150-007-000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Los Angeles</td>
                    <td>2061-002-052</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Madera</td>
                    <td>049262002000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Marin</td>
                    <td>199-093-26</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Mariposa</td>
                    <td>021-110-018-000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Mendocino</td>
                    <td>03241033</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Merced</td>
                    <td>005080004000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Modoc</td>
                    <td>011-340-017-000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Mono</td>
                    <td>033421035000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Monterey</td>
                    <td>243-221-018-000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Napa</td>
                    <td>011540005000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Nevada</td>
                    <td>016520003000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Placer</td>
                    <td>052-220-030-000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Plumas</td>
                    <td>001450013000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Riverside</td>
                    <td>845163021</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Sacramento</td>
                    <td>12105600660000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>San Benito</td>
                    <td>0210900080</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>San Bernardino</td>
                    <td>046239109</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>San Diego</td>
                    <td>3481121411</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>San Francisco</td>
                    <td>1939045</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>San Joaquin</td>
                    <td>24512033</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>San Luis Obispo</td>
                    <td>091-327-040</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>San Mateo</td>
                    <td>048014080</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Santa Barbara</td>
                    <td>004-008-037</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Santa Clara</td>
                    <td>36927009</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Santa Cruz</td>
                    <td>078-031-06</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Shasta</td>
                    <td>094380006000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Sierra</td>
                    <td>015-052-001</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Siskiyou</td>
                    <td>003-430-220</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Solano</td>
                    <td>0115082040</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Sonoma</td>
                    <td>001-173-010</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Stanislaus</td>
                    <td>018052037000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Sutter</td>
                    <td>13-240-033</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Tehama</td>
                    <td>075-250-031-000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Trinity</td>
                    <td>017-130-06-00</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Tulare</td>
                    <td>028-110-009</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Tuolumne</td>
                    <td>043-680-006-000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Ventura</td>
                    <td>1580132105</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Yolo</td>
                    <td>033190015000</td>
                  </tr>
                  <tr style={{ textAlign: 'center' }}>
                    <td>Yuba</td>
                    <td>044400005000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Modal>
      </div>
    </>
  )
}
